import { useState } from 'react';

import { useCatalog } from '../CatalogContext';
import { useContent } from '../ContentContext';
import { useLocation } from '../context/LocationContext';
import LocationGate from '../components/LocationGate';
import { PageHero, SectionHead, ProductGrid, ProductFilters, useProductFilters } from '../components/Common';

// Remembers a "Skip for now" so the ask doesn't reappear on every visit.
const ASK_KEY = 'gt_pin_asked';

// The shop: everything the admin has published, with live prices.
export default function ProductsPage() {
  const { loading, products, categories = [] } = useCatalog();
  const { brands = [] } = useContent();
  const { hasLocation } = useLocation();
  const [asked, setAsked] = useState(() => Boolean(sessionStorage.getItem(ASK_KEY)));
  const f = useProductFilters(products, categories, brands);

  // Prices and delivery depend on the pincode, so this is where we ask for it.
  // Setting it re-fetches the catalogue for that area automatically.
  const dismiss = () => {
    sessionStorage.setItem(ASK_KEY, '1');
    setAsked(true);
  };

  return (
    <>
      {!hasLocation && !asked ? <LocationGate onDone={dismiss} /> : null}

      <PageHero title="All Products" />

      <section>
        <div className="container">
          <SectionHead
            tag="Shop Online"
            title="All Products"
            text="Buy premium Golden Taj, Sunehra Taj and Shahi Pakwan rice — priced for your delivery area."
          />

          {loading ? (
            <p className="muted">Loading products…</p>
          ) : products.length ? (
            <>
              <ProductFilters {...f} count={f.filtered.length} />
              {f.filtered.length
                ? <ProductGrid products={f.filtered} />
                : <p className="muted">No products match this filter.</p>}
            </>
          ) : (
            <p className="muted">No products available yet.</p>
          )}
        </div>
      </section>
    </>
  );
}
